import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/get-pocket': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M407.6 64c22.7 0 40.4 18.2 40.4 40.6v135.2c0 124.7-99.8 224.2-223.8 224.2-124.5 0-224.2-99.5-224.2-224.2v-135.2c0-22.1 18.5-40.6 40.6-40.6h367zM245.6 332.5c111.9-107.5 114.8-105.4 114.8-123.2 0-16.9-13.8-30.7-30.7-30.7-16.9 0-14.9 2.4-105.5 89.3-89.1-85.5-88.2-89.3-105.2-89.3-16.9 0-30.7 13.8-30.7 30.7 0 18.1 1.2 14.3 114.9 123.2 11 11.1 30 11.8 42.4 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/get-pocket.js
// module id = 848
// module chunks = 0